<app-dealer-campaign-modules [contentModules]="dealerCampaign().contentModules" />
